import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Box, Button, Typography } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Navbar } from '../../component/shared/Navbar'
import { PageContainer } from '../../component/styled/PageContainer'

/** The frame the create and edit pages share, so their width and spacing stay in step. */
const Layout = ({ title, children }) => (
  <>
    <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
      <title>{title}</title>
    </Helmet>
    <Navbar />
    <PageContainer>
      <Box py={5} px={1}>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          flexWrap='wrap'
          gap={2}
          mb={2}
        >
          <Typography variant='h1'>{title}</Typography>
          <Button startIcon={<ChevronLeftIcon />} component={Link} to='/lucky-draw'>
            BACK
          </Button>
        </Box>
        {children}
      </Box>
    </PageContainer>
  </>
)

export default Layout
